import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { functions, db } from "../firebase"; // ensure db and functions are exported
import { doc, getDoc } from "firebase/firestore";
import "./BuyCredits.css"; // reuse your existing styles

const RedeemCode = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user_idx } = location.state || {};

  const [code, setCode] = useState("");
  //const [partner, setPartner] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [ideaCredit, setIdeaCredit] = useState(null);
  const [projectCredit, setProjectCredit] = useState(null);

  const redeemCode = httpsCallable(functions, "redeemCode");

  const fetchCredits = async () => {
    try {
      const userRef = doc(db, "users", user_idx);
      const snapshot = await getDoc(userRef);
      if (snapshot.exists()) {
        const data = snapshot.data();
        setIdeaCredit(data.ideaCredit || 0);
        setProjectCredit(data.projectCredit || 0);
      }
    } catch (err) {
      console.error("Error fetching credits:", err);
    }
  };
const handleRedeem = async () => {
  try {
    const result = await redeemCode({
      code: code.trim(),
      //partner: partner.trim(),
    });

    if (result.data.success) {
      setMessage("✅ Kod başarıyla kullanıldı!");
      navigate(-1);
    } else {
      setMessage(result.data.message || "❌ Kod geçersiz.");
    }
  } catch (err) {
    console.error("Redeem error:", err); // 👈 important for debugging
    setMessage(`❌ Hata: ${err.message || "Bilinmeyen hata"}`);
  }
};

  return (
    <div className="buy-credits-container">
      <div className="buy-credits-box">
        <h2>Kredi Kodu Kullan</h2>

        <div className="credit-selector">
          <label htmlFor="redeem-code">Kredi Kodu:</label>
          <input
            type="text"
            id="redeem-code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            disabled={loading}
          />
        </div>

        {/*<div className="credit-selector">
          <label htmlFor="partner-name">Partner Adı:</label>
          <input
            type="text"
            id="partner-name"
            value={partner}
            onChange={(e) => setPartner(e.target.value)}
            disabled={loading}
          />
        </div>*/}

        {message && <p>{message}</p>}

        {(ideaCredit !== null || projectCredit !== null) && (
          <div style={{ marginTop: "1rem" }}>
            <p>
              Mevcut Kavram Geliştirme Krediniz:{" "}
              <strong>{ideaCredit ?? 0}</strong>
            </p>
            <p>
              Mevcut Proje Krediniz: <strong>{projectCredit ?? 0}</strong>
            </p>
          </div>
        )}

        <div className="buycredit-confirm-buttons">
          <button onClick={handleRedeem} disabled={loading}>
            {loading ? "Kontrol Ediliyor..." : "Onayla"}
          </button>
          <button onClick={() => navigate(-1)}>İptal</button>
        </div>
      </div>
    </div>
  );
};

export default RedeemCode;
